import gql from "graphql-tag";

const CREATE_ORG_MULTI_TAG = gql`
  mutation createOrgEventsTarget(
    $appId: String
    $cart: String
    $name: String
    $orgId: ID
    $tagUpdateDate: DateTime
    $tag: JSON
  ) {
    updateOrgMultiTag(
      where: { id: $orgId }
      data: {
        appId: $appId
        cart: $cart
        name: $name
        tag: $tag
        tagUpdateDate: $tagUpdateDate
      }
    ) {
      id
      name
      eventsTarget {
        id
        name
        description
        pageViews
        signups
        transactions
        retailId
        cart
        test
        tag
        isAmplifyDefault
        segmentId
        segmentName
        tagUpdateDate
        uniqueDevices
        eventTags {
          id
          appId
        }
      }
    }
  }
`;

export default CREATE_ORG_MULTI_TAG;
